import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-section-subtitle',
  templateUrl: './section-subtitle.component.html',
  styleUrls: ['./section-subtitle.component.scss']
})
export class SectionSubtitleComponent {
  @Input() subtitle: string = '';
  @Input() isSmall: boolean = false;
}
